import { useState, useEffect, useCallback } from 'react';
import { parseSubdomain, getLandingPageConfig, DOMAIN_TYPES } from '../utils/domainResolver';

export function useDomainParams() {
  const [hostname, setHostname] = useState(null);
  const [landingPageConfig, setLandingPageConfig] = useState(null);

  useEffect(() => {
    const host = window.location.hostname.split(':')[0].toLowerCase();
    setHostname(host);
    const config = getLandingPageConfig(host);
    setLandingPageConfig(config);
  }, []);

  const resolve = useCallback(async (host) => {
    const cleanHost = host.split(':')[0].toLowerCase();
    const config = getLandingPageConfig(cleanHost);
    if (config) {
      return {
        type: config.type,
        branding: config.branding,
        landingPageKey: config.key
      };
    }
    const parsed = parseSubdomain(cleanHost);
    return {
      type: parsed.type,
      prefix: parsed.prefix,
      isMultiLevel: parsed.isMultiLevel
    };
  }, []);

  const clear = useCallback(() => {
    setHostname(null);
    setLandingPageConfig(null);
  }, []);

  return {
    hostname,
    landingPageConfig,
    isLandingPage: landingPageConfig !== null,
    paasId: null,
    saasId: null,
    tenantId: null,
    type: landingPageConfig?.type || null,
    branding: landingPageConfig?.branding || {},
    isLoading: false,
    error: null,
    resolve,
    clear
  };
}

export default useDomainParams;